import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Headings for a step.
 *
 * Every step renders as one question inside a grouped screen: the group header
 * is the h1, so each question's own title is an h2 beneath it.
 */
export const StepTitle = ({ children }: { children: React.ReactNode }) => (
  <h2 className='ob-q-title'>{children}</h2>
)

export const StepSubtitle = ({ children }: { children: React.ReactNode }) => (
  <p className='ob-q-subtitle'>{children}</p>
)

/**
 * The name of the language being learned, in the interface language. The server sends it in
 * English ('Chinese'); any other name it might send is shown as it comes.
 */
export const useLanguageName = (language?: string): string => {
  const { t } = useTranslation('onboarding')
  if (!language || language === 'Chinese') return t('languageName.chinese')
  return language
}
